import { fetchApi } from "../../fetchApi";
import {
  MembershipPlan,
  CompanySubscription,
  CreatePlanDto,
  UpdatePlanDto,
  SubscribePlanDto,
  UpdateSubscriptionDto,
  MembershipAnalytics,
  PlanStats,
  ProductCreationQuota,
} from "./types";

export const membershipApi = {
  // ===== MEMBERSHIP PLANS =====

  async getAllPlans(active?: boolean): Promise<MembershipPlan[]> {
    const params = active !== undefined ? `?active=${active}` : "";
    return fetchApi<MembershipPlan[]>(`/membership/plans${params}`, "GET");
  },

  async getActivePlans(): Promise<MembershipPlan[]> {
    return fetchApi<MembershipPlan[]>("/membership/plans?active=true", "GET");
  },

  async getPlanById(id: string): Promise<MembershipPlan> {
    return fetchApi<MembershipPlan>(`/membership/plans/${id}`, "GET");
  },

  async createPlan(data: CreatePlanDto): Promise<MembershipPlan> {
    return fetchApi<MembershipPlan>("/membership/plans", "POST", data);
  },

  async updatePlan(id: string, data: UpdatePlanDto): Promise<MembershipPlan> {
    return fetchApi<MembershipPlan>(`/membership/plans/${id}`, "PUT", data);
  },

  async deletePlan(id: string): Promise<void> {
    return fetchApi<void>(`/membership/plans/${id}`, "DELETE");
  },

  // ===== COMPANY SUBSCRIPTIONS =====

  async getCompanySubscription(): Promise<CompanySubscription | null> {
    return fetchApi<CompanySubscription | null>(
      "/membership/subscription",
      "GET"
    );
  },

  async getCompanySubscriptionHistory(): Promise<CompanySubscription[]> {
    return fetchApi<CompanySubscription[]>(
      "/membership/subscription/history",
      "GET"
    );
  },

  async getProductCreationQuota(): Promise<ProductCreationQuota> {
    return fetchApi<ProductCreationQuota>(
      "/membership/subscription/product-quota",
      "GET"
    );
  },

  async subscribeToPlan(data: SubscribePlanDto): Promise<CompanySubscription> {
    return fetchApi<CompanySubscription>("/membership/subscribe", "POST", data);
  },

  async updateSubscription(
    id: string,
    data: UpdateSubscriptionDto
  ): Promise<CompanySubscription> {
    return fetchApi<CompanySubscription>(
      `/membership/subscription/${id}`,
      "PUT",
      data
    );
  },

  async cancelSubscription(id: string): Promise<CompanySubscription> {
    return fetchApi<CompanySubscription>(
      `/membership/subscription/${id}`,
      "DELETE"
    );
  },

  async getSubscriptionById(id: string): Promise<CompanySubscription> {
    return fetchApi<CompanySubscription>(
      `/membership/subscription/${id}`,
      "GET"
    );
  },

  // ===== ANALYTICS =====

  async getMembershipAnalytics(): Promise<MembershipAnalytics> {
    return fetchApi<MembershipAnalytics>("/membership/analytics", "GET");
  },

  async getPlanStats(planId: string): Promise<PlanStats> {
    return fetchApi<PlanStats>(`/membership/plans/${planId}/stats`, "GET");
  },
};
